export type ButtonVariant = 'primary' | 'secondary';

export function getLinkClasses(): string {
  return 'text-[#3A3168] font-normal hover:text-[#3A3168] hover:font-semibold transition-colors';
}

export function getButtonClasses(variant: ButtonVariant = 'secondary'): string {
  if (variant === 'primary') {
    return 'inline-flex items-center rounded-md bg-[#3A3168] px-4 py-2 text-white hover:bg-[#322a5b] focus:outline-none focus:ring-2 focus:ring-[#3A3168] focus:ring-offset-1';
  }
  return 'inline-flex items-center rounded-md border border-[#3A3168] px-4 py-2 text-[#3A3168] hover:bg-[#f4f4f8] focus:outline-none focus:ring-2 focus:ring-[#3A3168] focus:ring-offset-1';
}